export default __webpack_public_path__ + "static/media/painting27.2e5ac096.jpeg";